export const ESpinnerSize = {
  none: 0,
  xs: 0.3,
  small: 1,
  medium: 2,
  large: 3,
  xl: 4
}

export const EOverlayTheme = {
  light: 0,
  dark: 1
}

export const EAlertType = {
  normal: 0,
  warning: 1,
  danger: 2
}

export const EButtonType = {
  primary: 0,
  secondary: 1,
  tertiary: 2,
  gray: 3,
  custom: 99
}

export const EInputType = {
  text: 'text',
  email: 'email',
  url: 'url',
  password: 'password',
  number: 'number',
  tel: 'tel'
}

export const ESortDirections = {
  asc: 'asc',
  desc: 'desc'
}

export const EChipType = {
  info: 0,
  danger: 1,
  success: 2,
  warning: 3,
  custom: 99
}

export const EModal = {
  go_to_holofuel: 0
}
